import { createSelector } from '@reduxjs/toolkit';
import { type RootState } from 'automations/store';
import { AutomationMode } from 'automations/types/automation';

const baseSelector = (state: RootState) => state.automations.automationConfig;

export const automationIdSelector = (state: RootState) => baseSelector(state).automationId;

export const automationModeSelector = createSelector(
  baseSelector,
  (state) => state.mode,
);

export const isReportModeSelector = createSelector(
  automationModeSelector,
  (mode) => mode === AutomationMode.individualReport || mode === AutomationMode.commonReport,
);

export const isLiveEditEnabledSelector = createSelector(
  automationModeSelector,
  (mode) => mode === AutomationMode.liveEdit,
);

export const automationStatusSelector = createSelector(
  baseSelector,
  (state) => state.automationData?.status,
);

export const isDebugModeSelector = createSelector(
  baseSelector,
  (state) => state.debug,
);

export const isReportPanelOpenSelector = createSelector(
  baseSelector,
  (state) => state.reportPanelOpen,
);

export const automationDataSelector = createSelector(
  baseSelector,
  (state) => state.automationData,
);

export const reportExecutionIdSelector = createSelector(
  baseSelector,
  (state) => state.reportExecutionId,
);

export const automationReportDataSelector = createSelector(
  baseSelector,
  (state) => state.automationReportData,
);

export const canvasAlertSelector = createSelector(
  baseSelector,
  (state) => state.canvasAlert,
);
